import { isNumber } from 'util';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gwiazdki'
})
export class GwiazdkiPipe implements PipeTransform {

  transform(liczbaGwiadek: number): string {
    if (liczbaGwiadek && isNumber(liczbaGwiadek)) {
      let gwiazdki = '';
      for (let i = 0; i < liczbaGwiadek; i++)
        gwiazdki += '*';
      return gwiazdki;
    }
    return null;
  }

}
